export default __webpack_public_path__ + "media/a3b1389be43d75cf43d61cce071e3ce6c31ccb1cad77982667c3cc4f901133af.svg";